import { FormikProps, getIn } from "formik";
import _ from "lodash";

import { parseISO } from "utils/datetime";

import DatePicker from "components/DatePicker";

import { ITransactionValuesForm } from "entities/Deal/sdk";

export interface ITransactionDatePickerField {
  formik: FormikProps<ITransactionValuesForm>;
  label: string;
  fieldName: string;
  onChange: (value: Date | null) => void;
}

const TransactionDatePicker = ({
  formik,
  onChange,
  label,
  fieldName,
}: ITransactionDatePickerField) => (
  <DatePicker
    label={label}
    onChange={onChange}
    slotProps={{
      field: { clearable: true },
      inputAdornment: {
        position: "start",
      },
    }}
    value={
      !_.isNil(
        getIn(formik.values.tax_credit_allocation_transaction, fieldName)
      )
        ? parseISO(
            getIn(formik.values.tax_credit_allocation_transaction, fieldName)
          )
        : null
    }
  />
);

export default TransactionDatePicker;
